// the logged-in user is stored in localStorage as { user: {...} } by the login page

// whether the logged-in user has verified their email
export const isStoredUserVerified = () => {
    try {
        return Boolean(JSON.parse(localStorage.getItem('user'))?.user?.is_email_verified)
    } catch (e) {
        return false
    }
}

// update the stored flag (after verifying, or when the API says the email isn't verified)
export const setStoredUserVerified = (verified) => {
    try {
        const stored = JSON.parse(localStorage.getItem('user'))
        if (stored?.user) {
            stored.user.is_email_verified = verified
            localStorage.setItem('user', JSON.stringify(stored))
        }
    } catch (e) {
        // nothing stored: the next login fetches the flag again
    }
}

// the stored user's email, for the "please verify" screen
export const storedUserEmail = () => {
    try {
        return JSON.parse(localStorage.getItem('user'))?.user?.email || ''
    } catch (e) {
        return ''
    }
}
